module.exports = __webpack_public_path__ + "img/22.f10baf30.png";